module.exports = __webpack_public_path__ + "cdebd452beb02f5afe8d60a731e71573.usdz";